import { NgModule } from '@angular/core';
import { ScriptLoaderService } from './scriptLoader.service';
import { MockProviderService } from './mockProvider.service';
import { BrowserUtilsService } from './browserUtils.service';
import { CSVService } from './csv.service';

@NgModule({
    providers: [
        ScriptLoaderService,
        MockProviderService,
        BrowserUtilsService,
        CSVService
    ]
})
export class UtilModule {
}